import {
    LOAD_TAX_SETTINGS_SUCCESS,
    SAVE_TAX_SETTINGS_SUCCESS,
    CLEAR_TAX_SETTINGS
} from "../../../../actions/types";

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_TAX_SETTINGS_SUCCESS:
            return action.payload;
        case SAVE_TAX_SETTINGS_SUCCESS:
            return action.payload;
        case CLEAR_TAX_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/restaurant/TaxSettingsReducer.js